import { Flex, TableColumnsType } from 'antd';
import * as Component from 'components';
import {
  TransferDataHandlerInterface,
  TransferDataSourceInterface,
} from 'components/transfer/Transfer';
import { ContentInterface } from 'content/type';
import { observer } from 'mobx-react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { contentApiService } from 'service/api/contentApiService';
import { playlistContentListService } from '../services/playlistContentListService';
import './PlaylistContentList.css';

const ContentList: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const filterOption = (input: string, item: ContentInterface): boolean =>
    item.title?.includes(input);

  const mapToTransferItem = (content: ContentInterface): TransferDataSourceInterface => ({
    ...content,
    key: content.id,
    name: content.title,
    disabled: false,
  });

  const dataHandler: TransferDataHandlerInterface = {
    fetchSourceData: async (query: Record<string, string>) => {
      const { results, count } = await contentApiService.fetch(new URLSearchParams(query));
      return {
        data: results.map(mapToTransferItem),
        count,
      };
    },
    fetchTargetData: async (query: Record<string, string>) => {
      const playlistContents = await playlistContentListService.fetch(
        new URLSearchParams({
          ...query,
          playlist_id: id!,
        })
      );
      return {
        data: playlistContents.results.map(mapToTransferItem),
        count: playlistContents.count,
      };
    },
    createWithParentId: async (ids: number[]) => {
      await playlistContentListService.createContentListInPlaylist(Number(id), ids);
    },
    deleteWithParentId: async (ids: number[]) => {
      await playlistContentListService.deleteContentListInPlaylist(Number(id), ids);
    },
  };

  const columns: TableColumnsType<ContentInterface & TransferDataSourceInterface> = [
    {
      dataIndex: 'id',
      title: 'ID',
      sorter: true,
    },
    {
      dataIndex: 'name',
      title: 'Name',
      render: (_, record): React.ReactNode => {
        return (
          <Flex align="center" gap="small">
            <span>{record.name}</span>
          </Flex>
        );
      },
    },
    {
      dataIndex: 'episode_order',
      title: 'Episode Order',
      sorter: true,
    },
    {
      dataIndex: 'content_type',
      title: 'Type',
    },
  ];

  return (
    <Flex align="start" gap="middle" vertical>
      <Component.TransferComponent
        disabled={false}
        dataHandler={dataHandler}
        filterOption={filterOption}
        columns={columns}
      />
    </Flex>
  );
};

export default observer(ContentList);
